import { render, staticRenderFns } from "./list-banners.vue?vue&type=template&id=2dd3721c&"
import script from "./list-banners.vue?vue&type=script&lang=js&"
export * from "./list-banners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports